enum Language {
  English = "en",
  Russian = "ru",
  German = "de",
}

export default Language;
